module.exports = __webpack_public_path__ + "static/media/35pic.b4f5a26e.jpg";